export default {
  en: {
    title: 'Mistakes',
    topicsTitle: 'Topics',
    emptyTopics: 'No mistakes found yet — great result!',
    loadingSr: 'Loading statistics',
    emptyCorrections: 'Well done! No mistakes.',
    deleteAria: 'Delete: {{original}}',
    loadingCorrectionsSr: 'Loading mistakes',
  },
  ru: {
    title: 'Ошибки',
    topicsTitle: 'Темы',
    emptyTopics: 'Пока ни одной ошибки не найдено — отличный результат!',
    loadingSr: 'Загружаю статистику',
    emptyCorrections: 'Вы молодцы! Ошибок нет.',
    deleteAria: 'Удалить: {{original}}',
    loadingCorrectionsSr: 'Загружаю ошибки',
  },
  de: {
    title: 'Fehler',
    topicsTitle: 'Themen',
    emptyTopics: 'Noch keine Fehler gefunden — starkes Ergebnis!',
    loadingSr: 'Statistiken werden geladen',
    emptyCorrections: 'Gut gemacht! Keine Fehler.',
    deleteAria: 'Löschen: {{original}}',
    loadingCorrectionsSr: 'Fehler werden geladen',
  },
  pt: {
    title: 'Erros',
    topicsTitle: 'Tópicos',
    emptyTopics: 'Nenhum erro encontrado ainda — ótimo resultado!',
    loadingSr: 'Carregando estatísticas',
    emptyCorrections: 'Muito bem! Nenhum erro.',
    deleteAria: 'Excluir: {{original}}',
    loadingCorrectionsSr: 'Carregando erros',
  },
  fr: {
    title: 'Erreurs',
    topicsTitle: 'Sujets',
    emptyTopics: 'Aucune erreur trouvée pour l’instant — excellent résultat !',
    loadingSr: 'Chargement des statistiques',
    emptyCorrections: 'Bravo ! Aucune erreur.',
    deleteAria: 'Supprimer : {{original}}',
    loadingCorrectionsSr: 'Chargement des erreurs',
  },
  es: {
    title: 'Errores',
    topicsTitle: 'Temas',
    emptyTopics: 'Todavía no se ha encontrado ningún error — ¡qué buen resultado!',
    loadingSr: 'Cargando estadísticas',
    emptyCorrections: '¡Bien hecho! No hay errores.',
    deleteAria: 'Eliminar: {{original}}',
    loadingCorrectionsSr: 'Cargando errores',
  },
};
